/* @flow */
import * as React from 'react';
import Config from 'Config';
import gql from 'graphql-tag';
import QuickPromotion from 'entities/QuickPromotion';
import QuickPromotionModal from 'components/QuickPromotionModal';
import QuickPromotionActions from 'actions/QuickPromotionActions';
import { graphql } from 'react-apollo';
import { mountModal } from 'lib/modal';

type Props = {
  promotion?: ?QuickPromotion,
};

export class AppboyPreaskModal extends React.Component<Props> {
  componentDidMount() {
    this.checkForPrompts();
  }

  componentDidUpdate() {
    this.checkForPrompts();
  }

  checkForPrompts() {
    const appboy = window.appboy;
    const { promotion } = this.props;
    if (
      !this.shown &&
      appboy &&
      (Config.Environment.APPBOY_ENVIRONMENT === 'production' ||
        Config.Environment.APPBOY_ENVIRONMENT === 'test') &&
      appboy.isPushSupported() &&
      !appboy.isPushPermissionGranted() &&
      !appboy.isPushBlocked() &&
      promotion
    ) {
      this.shown = true;
      const modal = (
        <QuickPromotionModal
          triggeredContext={'appboy-preask:' + promotion.getPromotion()}
          promotion={promotion}
          onConfirm={this.requestPush}
          onCancel={() => {}}
          onRequestHide={() => {}}
        />
      );
      mountModal(modal, this);
      QuickPromotionActions.recordDismissal(promotion, 'dismissed');
    }
  }

  shown = false;

  requestPush() {
    const appboy = window.appboy;
    if (appboy) {
      appboy.registerAppboyPushMessages();
    }
  }

  render() {
    return null;
  }
}

const withData = graphql(
  gql`
    query AppboyPreaskModal {
      me {
        id
        uuid
        quick_promotions(selectPromotions: ["web_appboy_preask"]) {
          promotion
          schema_version
          end_date
          type
          trigger
          header
          body
          image_url
          image_type
          dismissable
          primary_action {
            label
            action
            action_data
          }
          secondary_action {
            label
            action
            action_data
          }
        }
      }
    }
  `,
  {
    props: ({ data }) => {
      // Must handle the error (access it) or it will be re-thrown every time the me query updates.
      // http://dev.apollodata.com/react/api-queries.html#graphql-query-data-error
      if (data.error || !data.me) {
        return {};
      }

      const quickPromotions = data.me.quick_promotions;
      if (!Array.isArray(quickPromotions)) {
        return {};
      }

      return {
        promotion: quickPromotions.length ? QuickPromotion.fromJSON(quickPromotions[0]) : null,
      };
    },
  }
);

export default withData(AppboyPreaskModal);
